import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import logo from "./logo.png";

const Footer = () => {
  return (
    <footer className="page-footer" style={{ backgroundColor: "#222222" }}>
      <div className="container">
        <div className="row">
          <div className="col l6 s12 grow">
            <img
              src={logo}
              style={{ height: 70, width: 200, paddingTop: 10 }}
              alt="footer logo"
            />
            {/*<h5 className="white-text" style={{fontWeight: 'bold'}}>Company</h5>*/}
            <p className="grey-text text-lighten-4">
              Xtendliving combines next-generation telemedicine, telemonitoring
              and home health to provide you with immediate access to highly
              trained and experienced doctors and wellness experts.
            </p>
          </div>
          <div className="col l3 s12 grow">
            <h5 className="white-text" style={{ fontWeight: "bold" }}>
              Useful Links
            </h5>
            <ul>
              <li>
                <Link className="white-text" to="/">
                  Home
                </Link>
              </li>
              <li>
                <Link className="white-text" to="/about">
                  About Us
                </Link>
              </li>
              <li>
                <Link className="white-text" to="/solution">
                  Our Solutions
                </Link>
              </li>
              <li>
                <Link className="white-text" to="/">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link className="white-text" to="/tnc">
                  Terms Of Use
                </Link>
              </li>
            </ul>
          </div>
          <div className="col l3 s12 grow">
            <h5 className="white-text" style={{ fontWeight: "bold" }}>
              Contact Us
            </h5>
            <ul>
              <li>
                <Link className="white-text" to="/">
                  support@xtendliving.com
                </Link>
              </li>
              <li>
                <Link className="white-text" to="/">
                  +123456789
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-copyright black">
        <div className="container">
          <div className="center">
            @ Xtendliving 2020 - All Rights Reserved.
          </div>
          <div className="center iconpadding">
            <i className="fa fa-facebook-square custom"></i>
            <i className="fa fa-twitter-square custom"></i>
            <i className="fa fa-linkedin-square custom"></i>
            <i className="fa fa-instagram custom"></i>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
